<h1 mat-dialog-title>MedInThePocket</h1>
<div mat-dialog-content>
	<div class="flex flex-row items-center justify-between">
		<div class="text-xl">{{ message }}</div>
		<img
			src="../../../../assets/ng_error_robot.png"
			class="w-[80px]"
			alt="robot_error" />
	</div>
</div>
<div
	mat-dialog-actions
	[align]="'end'">
	<button
		mat-button
		mat-dialog-close>
		{{ "core.close" | translate }}
	</button>
</div>
